import React from "react";
import { Link } from "react-router-dom";
import { Lock, Shield, MapPin, Award } from "lucide-react";

/**
 * Discreet inline row of trust badges.
 * Drop it on any page where you want to reassure the user about security & privacy.
 *
 * Usage: <TrustBadges /> or <TrustBadges compact /> for the slim version.
 */
export default function TrustBadges({ compact = false, className = "" }) {
  const items = [
    { icon: Lock, label: "Connexion sécurisée", color: "emerald", to: "/securite" },
    { icon: Shield, label: "RGPD", color: "blue", to: "/securite" },
    { icon: MapPin, label: "Données en France", color: "violet", to: "/securite" },
    { icon: Award, label: "Sans tracker pub", color: "amber", to: "/securite" },
  ];
  const colorMap = {
    emerald: "bg-emerald-50 border-emerald-200 text-emerald-800",
    blue: "bg-blue-50 border-blue-200 text-blue-800",
    violet: "bg-violet-50 border-violet-200 text-violet-800",
    amber: "bg-amber-50 border-amber-200 text-amber-800",
  };

  return (
    <div
      className={`flex flex-wrap items-center ${compact ? "gap-1.5" : "gap-2"} ${className}`}
      data-testid="trust-badges"
      aria-label="Garanties sécurité et confidentialité"
    >
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <Link
            key={it.label}
            to={it.to}
            className={`inline-flex items-center gap-1.5 ${compact ? "px-2 py-1 text-[10px]" : "px-2.5 py-1 text-xs"} rounded-full border font-semibold transition-transform hover:scale-105 ${colorMap[it.color]}`}
            data-testid={`trust-badge-${it.color}`}
            title="En savoir plus sur la sécurité"
          >
            <Icon size={compact ? 10 : 12} />
            <span>{it.label}</span>
          </Link>
        );
      })}
    </div>
  );
}
